export default __webpack_public_path__ + "static/7-9cfd36f11839799c6bcfbaf17b41a3ea.png";